import { createEan, editEan } from '../../_services/ean.service';
import { 
    validateEan
} from './model';

export const createEanEvent = async (body) => {
    validateEan(body);
    let res = await createEan(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const editEanEvent = async (id, body) => {
    validateEan(body);
    let res = await editEan(body, id);
    if(! res.ok) throw new Error(res.error);
    return res;
}